// extracted by mini-css-extract-plugin
export default {"light":"gTqut","dark":"rCh6h"};